import { DropdownItem } from '@bybeam/platform-types';
import { mapParentChildKeys } from '../../fields/dropdown.js';

export const LANGUAGES: DropdownItem[] = [
  { value: 'af', label: 'Afrikaans' },
  { value: 'sq', label: 'Albanian - <span lang="sq">shqip</span>' },
  { value: 'am', label: 'Amharic - <span lang="am">አማርኛ</span>' },
  { value: 'ar', label: 'Arabic - <span lang="ar">العربية</span>' },
  { value: 'an', label: 'Aragonese - <span lang="an">aragonés</span>' },
  { value: 'hy', label: 'Armenian - <span lang="hy">հայերեն</span>' },
  { value: 'ast', label: 'Asturian - <span lang="ast">asturianu</span>' },
  { value: 'az', label: 'Azerbaijani - <span lang="az">azərbaycan dili</span>' },
  { value: 'eu', label: 'Basque - <span lang="eu">euskara</span>' },
  { value: 'be', label: 'Belarusian - <span lang="be">беларуская</span>' },
  { value: 'bn', label: 'Bengali - <span lang="bn">বাংলা</span>' },
  { value: 'bs', label: 'Bosnian - <span lang="bs">bosanski</span>' },
  { value: 'br', label: 'Breton - <span lang="br">brezhoneg</span>' },
  { value: 'bg', label: 'Bulgarian - <span lang="bg">български</span>' },
  { value: 'ca', label: 'Catalan - <span lang="ca">català</span>' },
  { value: 'ckb', label: 'Central Kurdish - <span lang="ckb">کوردی (دەستنوسی عەرەبی</span>' },
  { value: 'zh', label: 'Chinese - <span lang="zh">中文</span>' },
  { value: 'zh-HK', label: 'Chinese (Hong Kong) -  <span lang="zh">中文（香港）</span>' },
  { value: 'zh-CN', label: 'Chinese (Simplified) - <span lang="zh">中文（简体）</span>' },
  { value: 'zh-TW', label: 'Chinese (Traditional) - <span lang="zh">中文（繁體）</span>' },
  { value: 'co', label: 'Corsican' },
  { value: 'hr', label: 'Croatian - <span lang="hr">hrvatski</span>' },
  { value: 'cs', label: 'Czech - <span lang="cs">čeština</span>' },
  { value: 'da', label: 'Danish - <span lang="da">dansk</span>' },
  { value: 'nl', label: 'Dutch - <span lang="nl">Nederlands</span>' },
  { value: 'en', label: 'English' },
  { value: 'en-AU', label: 'English (Australia)' },
  { value: 'en-CA', label: 'English (Canada)' },
  { value: 'en-IN', label: 'English (India)' },
  { value: 'en-NZ', label: 'English (New Zealand)' },
  { value: 'en-ZA', label: 'English (South Africa)' },
  { value: 'en-GB', label: 'English (United Kingdom)' },
  { value: 'en-US', label: 'English (United States)' },
  { value: 'eo', label: 'Esperanto - <span lang="eo">esperanto</span>' },
  { value: 'et', label: 'Estonian - <span lang="et">eesti</span>' },
  { value: 'fo', label: 'Faroese - <span lang="fo">føroyskt</span>' },
  { value: 'fil', label: 'Filipino' },
  { value: 'fi', label: 'Finnish - <span lang="fi">suomi</span>' },
  { value: 'fr', label: 'French - <span lang="fr">français</span>' },
  { value: 'fr-CA', label: 'French (Canada) - <span lang="fr">français (Canada)</span>' },
  { value: 'fr-FR', label: 'French (France) - <span lang="fr">français (France)</span>' },
  { value: 'fr-CH', label: 'French (Switzerland) - <span lang="fr">français (Suisse)</span>' },
  { value: 'gl', label: 'Galician - <span lang="gl">galego</span>' },
  { value: 'ka', label: 'Georgian - <span lang="ka">ქართული</span>' },
  { value: 'de', label: 'German - <span lang="de">Deutsch</span>' },
  { value: 'de-AT', label: 'German (Austria) - <span lang="de">Deutsch (Österreich)</span>' },
  { value: 'de-DE', label: 'German (Germany) - <span lang="de">Deutsch (Deutschland)</span>' },
  {
    value: 'de-LI',
    label: 'German (Liechtenstein) - <span lang="de">Deutsch (Liechtenstein)</span>',
  },
  { value: 'de-CH', label: 'German (Switzerland) - <span lang="de">Deutsch (Schweiz)</span>' },
  { value: 'el', label: 'Greek - <span lang="el">Ελληνικά</span>' },
  { value: 'gn', label: 'Guarani' },
  { value: 'gu', label: 'Gujarati - <span lang="gu">ગુજરાતી</span>' },
  { value: 'ha', label: 'Hausa' },
  { value: 'haw', label: 'Hawaiian - <span lang="haw">ʻŌlelo Hawaiʻi</span>' },
  { value: 'he', label: 'Hebrew - <span lang="he">עברית</span>' },
  { value: 'hi', label: 'Hindi - <span lang="hi">हिन्दी</span>' },
  { value: 'hu', label: 'Hungarian - <span lang="hu">magyar</span>' },
  { value: 'is', label: 'Icelandic - <span lang="is">íslenska</span>' },
  { value: 'id', label: 'Indonesian - Indonesia' },
  { value: 'ia', label: 'Interlingua' },
  { value: 'ga', label: 'Irish - <span lang="ga">Gaeilge</span>' },
  { value: 'it', label: 'Italian - <span lang="it">italiano</span>' },
  { value: 'it-IT', label: 'Italian (Italy) - <span lang="it">italiano (Italia)</span>' },
  { value: 'it-CH', label: 'Italian (Switzerland) - <span lang="it">italiano (Svizzera)</span>' },
  { value: 'ja', label: 'Japanese - <span lang="ja">日本語</span>' },
  { value: 'kn', label: 'Kannada - <span lang="kn">ಕನ್ನಡ</span>' },
  { value: 'kk', label: 'Kazakh - <span lang="kk">қазақ тілі</span>' },
  { value: 'km', label: 'Khmer - <span lang="km">ខ្មែរ</span>' },
  { value: 'ko', label: 'Korean - <span lang="ko">한국어</span>' },
  { value: 'ku', label: 'Kurdish - <span lang="ku">Kurdî</span>' },
  { value: 'ky', label: 'Kyrgyz - <span lang="ky">кыргызча</span>' },
  { value: 'lo', label: 'Lao - <span lang="lo">ລາວ</span>' },
  { value: 'la', label: 'Latin' },
  { value: 'lv', label: 'Latvian - <span lang="lv">latviešu</span>' },
  { value: 'ln', label: 'Lingala - <span lang="ln">lingála</span>' },
  { value: 'lt', label: 'Lithuanian - <span lang="lt">lietuvių</span>' },
  { value: 'mk', label: 'Macedonian - <span lang="mk">македонски</span>' },
  { value: 'ms', label: 'Malay - <span lang="ms">Bahasa Melayu</span>' },
  { value: 'ml', label: 'Malayalam - <span lang="ml">മലയാളം</span>' },
  { value: 'mt', label: 'Maltese - <span lang="mt">Malti</span>' },
  { value: 'mr', label: 'Marathi - <span lang="mr">मराठी</span>' },
  { value: 'mn', label: 'Mongolian - <span lang="mn">монгол</span>' },
  { value: 'ne', label: 'Nepali - <span lang="ne">नेपाली</span>' },
  { value: 'no', label: 'Norwegian - <span lang="no">norsk</span>' },
  { value: 'nb', label: 'Norwegian Bokmål - <span lang="nb">norsk bokmål</span>' },
  { value: 'nn', label: 'Norwegian Nynorsk - <span lang="nn">nynorsk</span>' },
  { value: 'oc', label: 'Occitan' },
  { value: 'or', label: 'Oriya - <span lang="or">ଓଡ଼ିଆ</span>' },
  { value: 'om', label: 'Oromo - <span lang="om">Oromoo</span>' },
  { value: 'ps', label: 'Pashto - <span lang="ps">پښتو</span>' },
  { value: 'fa', label: 'Persian - <span lang="fa">فارسی</span>' },
  { value: 'pl', label: 'Polish - <span lang="pl">polski</span>' },
  { value: 'pt', label: 'Portuguese - <span lang="pt">português</span>' },
  { value: 'pt-BR', label: 'Portuguese (Brazil) - <span lang="pt">português (Brasil)</span>' },
  { value: 'pt-PT', label: 'Portuguese (Portugal) - <span lang="pt">português (Portugal)</span>' },
  { value: 'pa', label: 'Punjabi - <span lang="pa">ਪੰਜਾਬੀ</span>' },
  { value: 'qu', label: 'Quechua' },
  { value: 'ro', label: 'Romanian - <span lang="ro">română</span>' },
  { value: 'mo', label: 'Romanian (Moldova) - <span lang="mo">română (Moldova)</span>' },
  { value: 'rm', label: 'Romansh - <span lang="rm">rumantsch</span>' },
  { value: 'ru', label: 'Russian - <span lang="ru">русский</span>' },
  { value: 'gd', label: 'Scottish Gaelic' },
  { value: 'sr', label: 'Serbian - <span lang="sr">српски</span>' },
  { value: 'sh', label: 'Serbo-Croatian - <span lang="sh">Srpskohrvatski</span>' },
  { value: 'sn', label: 'Shona - <span lang="sn">chiShona</span>' },
  { value: 'sd', label: 'Sindhi' },
  { value: 'si', label: 'Sinhala - <span lang="si">සිංහල</span>' },
  { value: 'sk', label: 'Slovak - <span lang="sk">slovenčina</span>' },
  { value: 'sl', label: 'Slovenian - <span lang="sl">slovenščina</span>' },
  { value: 'so', label: 'Somali - <span lang="so">Soomaali</span>' },
  { value: 'st', label: 'Southern Sotho' },
  { value: 'es', label: 'Spanish - <span lang="es">español</span>' },
  { value: 'es-AR', label: 'Spanish (Argentina) - <span lang="es">español (Argentina)</span>' },
  {
    value: 'es-419',
    label: 'Spanish (Latin America) - <span lang="es">español (Latinoamérica)</span>',
  },
  { value: 'es-MX', label: 'Spanish (Mexico) - <span lang="es">español (México)</span>' },
  { value: 'es-ES', label: 'Spanish (Spain) - <span lang="es">español (España)</span>' },
  {
    value: 'es-US',
    label: 'Spanish (United States) - <span lang="es">español (Estados Unidos)</span>',
  },
  { value: 'su', label: 'Sundanese' },
  { value: 'sw', label: 'Swahili - <span lang="sw">Kiswahili</span>' },
  { value: 'sv', label: 'Swedish - <span lang="sv">svenska</span>' },
  { value: 'tg', label: 'Tajik - <span lang="tg">тоҷикӣ</span>' },
  { value: 'ta', label: 'Tamil - <span lang="ta">தமிழ்</span>' },
  { value: 'tt', label: 'Tatar' },
  { value: 'te', label: 'Telugu - <span lang="te">తెలుగు</span>' },
  { value: 'th', label: 'Thai - <span lang="th">ไทย</span>' },
  { value: 'ti', label: 'Tigrinya - <span lang="ti">ትግርኛ</span>' },
  { value: 'to', label: 'Tongan - <span lang="to">lea fakatonga</span>' },
  { value: 'tr', label: 'Turkish - <span lang="tr">Türkçe</span>' },
  { value: 'tk', label: 'Turkmen' },
  { value: 'tw', label: 'Twi' },
  { value: 'uk', label: 'Ukrainian - <span lang="uk">українська</span>' },
  { value: 'ur', label: 'Urdu - <span lang="ur">اردو</span>' },
  { value: 'ug', label: 'Uyghur' },
  { value: 'uz', label: 'Uzbek - <span lang="uz">o‘zbek</span>' },
  { value: 'vi', label: 'Vietnamese - <span lang="vi">Tiếng Việt</span>' },
  { value: 'wa', label: 'Walloon - wa' },
  { value: 'cy', label: 'Welsh - <span lang="cy">Cymraeg</span>' },
  { value: 'fy', label: 'Western Frisian' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'yi', label: 'Yiddish' },
  { value: 'yo', label: 'Yoruba - <span lang="yo">Èdè Yorùbá</span>' },
  { value: 'zu', label: 'Zulu - <span lang="zu">isiZulu</span>' },
];

export const LANGUAGES_SHORTLIST: DropdownItem[] = [
  { label: 'Chinese - <span lang="zh">中文</span>', value: 'chinese' },
  { label: 'Spanish - <span lang="es">español</span>', value: 'spanish' },
  { label: 'English', value: 'english' },
  { label: 'Hindi - <span lang="hi">हिन्दी</span>', value: 'hindi' },
  { label: 'Arabic - <span lang="ar">العربية</span>', value: 'arabic' },
  { label: 'Portuguese - <span lang="pt">português</span>', value: 'portuguese' },
  { label: 'Bengali - <span lang="bn">বাংলা</span>', value: 'bengali' },
  { label: 'Russian - <span lang="ru">русский</span>', value: 'russian' },
  { label: 'Japanese - <span lang="ja">日本語</span>', value: 'japanese' },
  { label: 'Punjabi - <span lang="pa">ਪੰਜਾਬੀ</span>', value: 'punjabi' },
];

export const NOT_SHOW_IN_LIST: DropdownItem = {
  label: 'Not shown in the list (specify)',
  value: 'other',
};

export const RACES: DropdownItem[] = mapParentChildKeys([
  {
    label: 'Indigenous / First Nation / American Indian and/or Alaskan Native',
    value: 'indigenousFirstNationAmericanIndianAndOrAlaskanNative',
    children: [NOT_SHOW_IN_LIST],
  },
  {
    label: 'Asian',
    value: 'asian',
    children: [
      { label: 'Cambodian', value: 'cambodian' },
      { label: 'Chinese', value: 'chinese' },
      { label: 'Filipino', value: 'filipino' },
      { label: 'Indian', value: 'indian' },
      { label: 'Japanese', value: 'japanese' },
      { label: 'Korean', value: 'korean' },
      { label: 'Laotian', value: 'laotian' },
      { label: 'Pakistani', value: 'pakistani' },
      { label: 'SriLankan', value: 'sriLankan' },
      { label: 'Vietnamese', value: 'vietnamese' },
      NOT_SHOW_IN_LIST,
    ],
  },
  {
    label: 'Black and/or African American',
    value: 'blackAndOrAfricanAmerican',
    children: [
      { label: 'African American', value: 'africanAmerican' },
      { label: 'Ethiopian', value: 'ethiopian' },
      { label: 'Ghanaian', value: 'ghanaian' },
      { label: 'Haitian', value: 'haitian' },
      { label: 'Jamaican', value: 'jamaican' },
      { label: 'Kenyan', value: 'kenyan' },
      { label: 'Nigerian', value: 'nigerian' },
      { label: 'Somali', value: 'somali' },
      NOT_SHOW_IN_LIST,
    ],
  },
  {
    label: 'Hispanic, or Latino/a/e or Latin American',
    value: 'hispanicOrLatino/a/eOrLatinAmerican',
    children: [
      { label: 'Colombian', value: 'colombian' },
      { label: 'Cuban', value: 'cuban' },
      { label: 'Dominican', value: 'dominican' },
      { label: 'Mexican', value: 'mexican' },
      { label: 'Puerto Rican', value: 'puertoRican ' },
      { label: 'Salvadoran', value: 'salvadoran' },
      NOT_SHOW_IN_LIST,
    ],
  },
  {
    label: 'Middle Eastern or North African',
    value: 'middleEasternOrNorthAfrican',
    children: [
      { label: 'Egyptian', value: 'egyptian' },
      { label: 'Iranian', value: 'iranian' },
      { label: 'Israeli', value: 'israeli' },
      { label: 'Jordanian', value: 'jordanian' },
      { label: 'Lebanese', value: 'lebanese' },
      { label: 'Moroccan', value: 'moroccan' },
      { label: 'Palestinian', value: 'palestinian' },
      { label: 'Syrian', value: 'syrian' },
      NOT_SHOW_IN_LIST,
    ],
  },
  {
    label: 'Native Hawaiian or Pacific Islander',
    value: 'nativeHawaiianOrPacificIslander',
    children: [
      { label: 'Chamorro', value: 'chamorro' },
      { label: 'Guamanian', value: 'guamanian' },
      { label: 'Figian', value: 'figian' },
      { label: 'Marshallese', value: 'marshallese' },
      { label: 'Native Hawaiian', value: 'nativeHawaiian' },
      { label: 'Samoan', value: 'samoan' },
      { label: 'Tongan', value: 'tongan' },
      NOT_SHOW_IN_LIST,
    ],
  },
  {
    label: 'White and/or European',
    value: 'whiteAndOrEuropean',
    children: [
      { label: 'German', value: 'german' },
      { label: 'Irish', value: 'irish' },
      { label: 'English', value: 'english' },
      { label: 'Italian', value: 'italian' },
      { label: 'Polish', value: 'polish' },
      { label: 'French', value: 'french' },
      NOT_SHOW_IN_LIST,
    ],
  },
]);
